export default "__VITE_ASSET__09789814__"